(function() {
    'use strict';
    angular.module('app')
        .controller('ServicesController', function(
            $timeout, 
            ServicesTableService, 
            $routeParams
        ){
            let vm = this;
            let filter = {};
            
           
            if($routeParams.carrierProfileId && $routeParams.serviceProfileId) {
                filter.carrierProfileId = $routeParams.carrierProfileId;
                filter.serviceProfileId = $routeParams.serviceProfileId;
            }

            $timeout(()=>{
                vm.ServicesTable = new ServicesTableService(filter).tableData;
            });
        });
})();


// WEBPACK FOOTER //
// ./js/controllers/ServicesController.js